import { render, staticRenderFns } from "./border-style.vue?vue&type=template&id=fe3256a2"
import script from "./border-style.vue?vue&type=script&lang=js"
export * from "./border-style.vue?vue&type=script&lang=js"
import style0 from "./border-style.vue?vue&type=style&index=0&id=fe3256a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports